var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error404"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/assets/images/404.svg","width":"326","height":"285"}}),_c('p',{staticClass:"title"},[_vm._v("Эта страница не найдена.")]),_c('p',[_c('router-link',{staticClass:"btn btn-bordered",attrs:{"to":{name:'main_page'}}},[_vm._v("На гавную")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }